import { authHeader } from '../helpers/auth-header';
import { config } from '../helpers/config';
import { commonServices } from './common.service';

export const mediaTimelineServices = {
    getAll,
    getByUserIdAndDatetimeRange,
};

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/UserMediaFile', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function getByUserIdAndDatetimeRange(userId, fromDate, toDate) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/UserMediaFile/userId/'+userId+'/fromDate/'+fromDate+'/toDate/'+toDate, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}


// WEBPACK FOOTER //
// ./src/services/mediaTimeline.service.js